import { useMutation, useQueryClient } from '@tanstack/react-query';
import { showSuccessNotification } from '../services/common';
import { createSpamWord, deleteSpamWord } from '../services/spam-word';

export const useCreateSpamWord = () => {
  const queryClient = useQueryClient();
  return useMutation(createSpamWord, {
    onSuccess: async () => {
      queryClient.invalidateQueries(['spamWords']).then(() => {});
      showSuccessNotification('Spam word created successfully');
    },
  });
};

export const useDeleteSpamWord = () => {
  const queryClient = useQueryClient();
  return useMutation(deleteSpamWord, {
    onSuccess: async () => {
      queryClient.invalidateQueries(['spamWords']).then(() => {});
      showSuccessNotification('Spam word deleted successfully');
    },
  });
};
